module.exports = __webpack_public_path__ + "static/media/adminlogo.438cd3db.svg";